import Swiper from "swiper";

import { Pagination, Navigation, Autoplay, EffectFade, Controller } from 'swiper/modules';

export default function(){
	const slidersContent  = document.querySelectorAll('[data-name=testimonials-slider]')

	if ( slidersContent.length > 0 ) {

		slidersContent.forEach(slider => {
			// Create the slider
			let swiperContent = new Swiper(slider, {
				modules: [Pagination, Navigation, Autoplay, EffectFade, Controller],

				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},

				autoplay: {
					delay: 5000,
				},
				loop: true,
				speed: 800,

				navigation: {                       
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				pagination: {
					el: slider.parentNode.parentNode.querySelector('.swiper-pagination-progressbar'),
					type: "progressbar",
				},
				on: {
					init: function() {
						slider.parentNode.parentNode.querySelector('.swiper-pagination-fraction').innerHTML = '<span class="swiper-pagination-current">' + (this.realIndex + 1) + '</span>' + ' / ' + '<span class="swiper-pagination-total">' + this.slides.length + '</span>';
					},
					slideChange: function () {
						slider.parentNode.parentNode.querySelector('.swiper-pagination-fraction').innerHTML = '<span class="swiper-pagination-current">' + (this.realIndex + 1) + '</span>' + ' / ' + '<span class="swiper-pagination-total">' + this.slides.length + '</span>';
					},
				},
			});

			const sliderPictures = slider.parentNode.parentNode.parentNode.querySelector('[data-name=testimonials-slider-pictures]')
			let swiperPictures

			if ( sliderPictures ){
				swiperPictures = new Swiper(sliderPictures, {
					modules: [Autoplay, EffectFade, Controller],
	
					effect: 'fade',
					fadeEffect: {
						crossFade: true
					},
	
					loop: true,
					speed: 800,
				});
			}

			swiperPictures.controller.control = swiperContent;
			swiperContent.controller.control  = swiperPictures;
		});
		
	}
}